import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";



export function disclaimerPage3(certInCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 350, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: "ISECURION has performed Mobile Application Security Audit on the request of " + certInCustomerName + ". The intent of which is to identify the existing vulnerabilities in the Mobile application and to explore the possibilities of these vulnerabilities may be exploited by malicious users, if not mitigated.",
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}